import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default function createStore() {
	return new Vuex.Store({
		state: {
			host: '',
			// deviceType: 'pc',
			deviceType: 'mobile',
			showDebug: false,
			ads: {
				scriptUrl: 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4688525518274277',
				home_insert: [
					{ class: 'adsbygoogle', style: 'display:block', 'data-ad-client': 'ca-pub-4688525518274277', 'data-ad-slot': '9170554297', 'data-ad-format': 'auto', 'data-full-width-responsive': 'true' },
					{ class: 'adsbygoogle', style: 'display:block', 'data-ad-client': 'ca-pub-4688525518274277', 'data-ad-slot': '7857472625', 'data-ad-format': 'auto', 'data-full-width-responsive': 'true' },
				],
				home_recommend: [{ class: 'adsbygoogle', style: 'display:block', 'data-ad-client': 'ca-pub-4688525518274277', 'data-ad-slot': '7857472625', 'data-ad-format': 'auto', 'data-full-width-responsive': 'true' }],

				sort_insert: [
					{ class: 'adsbygoogle', style: 'display:block', 'data-ad-client': 'ca-pub-4688525518274277', 'data-ad-slot': '9170554297', 'data-ad-format': 'auto', 'data-full-width-responsive': 'true' },
					{ class: 'adsbygoogle', style: 'display:block', 'data-ad-client': 'ca-pub-4688525518274277', 'data-ad-slot': '7857472625', 'data-ad-format': 'auto', 'data-full-width-responsive': 'true' },
				],

				detail_1: { class: 'adsbygoogle', style: 'display:block', 'data-ad-client': 'ca-pub-4688525518274277', 'data-ad-slot': '1870648774', 'data-ad-format': 'auto', 'data-full-width-responsive': 'true' },
				detail_insert: [{ class: 'adsbygoogle', style: 'display:block', 'data-ad-client': 'ca-pub-4688525518274277', 'data-ad-slot': '9557567105', 'data-ad-format': 'auto', 'data-full-width-responsive': 'true' }],
			},
			adPosConfig: {
				home_insert: [2, 5], //第二个前插入广告
				home_recommend: [2], //第二个前插入广告
				sort_insert: [1, 2], //第二个前插入广告
				detail_insert: [2], //第二个前插入广告
			},

			adsensConfig: {
				scriptUrl: 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4688525518274277',
				home_insert: [
					{ class: 'adsbygoogle', style: 'display:block', 'data-ad-client': 'ca-pub-4688525518274277', 'data-ad-slot': '9170554297', 'data-ad-format': 'auto', 'data-full-width-responsive': 'true' },
					{ class: 'adsbygoogle', style: 'display:block', 'data-ad-client': 'ca-pub-4688525518274277', 'data-ad-slot': '7857472625', 'data-ad-format': 'auto', 'data-full-width-responsive': 'true' },
				],
				home_recommend: [{ class: 'adsbygoogle', style: 'display:block', 'data-ad-client': 'ca-pub-4688525518274277', 'data-ad-slot': '7857472625', 'data-ad-format': 'auto', 'data-full-width-responsive': 'true' }],

				sort_insert: [
					{ class: 'adsbygoogle', style: 'display:block', 'data-ad-client': 'ca-pub-4688525518274277', 'data-ad-slot': '9170554297', 'data-ad-format': 'auto', 'data-full-width-responsive': 'true' },
					{ class: 'adsbygoogle', style: 'display:block', 'data-ad-client': 'ca-pub-4688525518274277', 'data-ad-slot': '7857472625', 'data-ad-format': 'auto', 'data-full-width-responsive': 'true' },
				],

				detail_1: { class: 'adsbygoogle', style: 'display:block', 'data-ad-client': 'ca-pub-4688525518274277', 'data-ad-slot': '1870648774', 'data-ad-format': 'auto', 'data-full-width-responsive': 'true' },
				detail_insert: [{ class: 'adsbygoogle', style: 'display:block', 'data-ad-client': 'ca-pub-4688525518274277', 'data-ad-slot': '9557567105', 'data-ad-format': 'auto', 'data-full-width-responsive': 'true' }],
			},
			domainConfig: {
				title: 'CreditCardEX.Review',
				designType: 2,
				icon: '/icon/3.png',
				IAMEMAIL: 'creditcardex.support@gmail.com',
				IAmURL: 'creditcardex.review',
				ABOUTUS: 'Dive into expert reviews guiding you to the perfect credit card. Explore insights, benefits, and comparisons to elevate your financial decisions with confidence and ease.',
				what: {
					title: 'What is CreditCardEX.Review?',
					des: 'Creditcardex.review is your go-to destination for expert credit card reviews. We provide in-depth analyses, comparisons, and insights to help you choose the most suitable credit card for your financial needs.\n',
				},
				how: {
					title: 'How to use CreditCardEX.Review？',
					des: 'CreditCardEx.review helps you compare and evaluate credit card options. Start by browsing categories like rewards or travel cards. Read detailed reviews and use the comparison tool to assess features such as interest rates and fees. Check user feedback for real-world insights, and apply directly through links provided on the site.',
				},
				meta: {
					title: ' ｜Comprehensive Credit Card Comparisons and Reviews',
					des: 'Discover the benefits of various credit card designs to find the ideal choice for your financial goals. Learn how to improve your credit score with smart usage, earn travel rewards, and enjoy shopping discounts.',
				},
				firebase: {
					apiKey: 'AIzaSyAHE2i3DdDrkuywDi7bh6IAPO-_2A_wbcA',
					authDomain: 'webs-89e21.firebaseapp.com',
					projectId: 'webs-89e21',
					storageBucket: 'webs-89e21.firebasestorage.app',
					messagingSenderId: '1096744027429',
					appId: '1:1096744027429:web:e2116f88c4bc2a1c9246cc',
					measurementId: 'G-7B5C4LT4QF',
				},
				ads: 'google.com, pub-6636220497603452, DIRECT, f08c47fec0942fa0',
				adsense: {
					scriptUrl: 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6636220497603452',
				},
			},
			categories: [],
			recommendList: [],
		},
		mutations: {
			setHost(state, host) {
				state.host = host
			},
			setTitle(state, title) {
				state.title = title
			},
			setDomain(state, domainConfig) {
				state.domainConfig = domainConfig
			},
			setDeviceType(state, deviceType) {
				state.deviceType = deviceType
			},
			setDebug(state, showDebug) {
				state.showDebug = showDebug
			},
			setAdsense(state, adsenseConfig) {
				state.adsensConfig = adsenseConfig
			},
			SET_CATEGORIES(state, categories) {
				state.categories = categories
			},
			SET_RECOMMEND_LIST(state, list) {
				state.recommendList = list
			},
		},
		getters: {
			showDebug: (state) => state.showDebug,
			deviceType: (state) => state.deviceType,
			host: (state) => state.host,
			adsensConfig: (state) => state.adsensConfig,
			adPosConfig: (state) => state.adPosConfig,
			domainConfig: (state) => state.domainConfig,
		},
	})
}
